import styled from 'styled-components';

export const H2Tag = styled.h2`
    text-align: ${({ textAlign }) => textAlign ? textAlign : 'center'};   
`